import { render, staticRenderFns } from "./project-detail-order-stat.vue?vue&type=template&id=5a50dddf&scoped=true&"
import script from "./project-detail-order-stat.vue?vue&type=script&lang=js&"
export * from "./project-detail-order-stat.vue?vue&type=script&lang=js&"
import style0 from "./project-detail-order-stat.vue?vue&type=style&index=0&id=5a50dddf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50dddf",
  null
  
)

export default component.exports